var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 22.0551C44 9.8807 34.144 0 22 0C9.856 0 0 9.8807 0 22.0551C0 32.7298 7.568 41.618 17.6 43.6692V28.6717H13.2V22.0551H17.6V16.5414C17.6 12.2847 21.054 8.82205 25.3 8.82205H30.8V15.4386H26.4C25.19 15.4386 24.2 16.4311 24.2 17.6441V22.0551H30.8V28.6717H24.2V44C35.31 42.8972 44 33.5018 44 22.0551Z",
    fill: "#9C9D9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.4d0a167605629968590647440007b5b3.svg";
export { ForwardRef as ReactComponent };